export default __webpack_public_path__ + "static/media/pbf.76d17fee.jpg";